import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import { DefaultButton } from '../../../../components/Button/Button';
import {
  DropzoneInput,
  LabelInput,
  SelectInput,
} from '../../../../components/Input/Input';
import { supabase } from '../../../../supabaseClient';
import { damageStatuses } from '../../ModalBudget/utils/models';

export const CreatingImage = (props) => {
  const {
    setIsOpen,
    isOpen,
    onChange,
    values,
    editingIndex,
    setEditingIndex,
    isFixedChecklist,
  } = props;

  const company = useSelector((state) => state.app.company || {});

  const editingValues = isFixedChecklist
    ? values?.entry_checklist?.fixed_checklist[editingIndex]
    : editingIndex !== null
    ? values?.entry_checklist?.image_register[editingIndex]
    : null;

  const [image, setImage] = useState(editingValues?.image || '');
  const [piece, setPiece] = useState(editingValues?.piece || '');
  const [description, setDescription] = useState(
    editingValues?.description || ''
  );
  const [observation, setObservation] = useState(
    editingValues?.observation || ''
  );

  function closeModal() {
    setIsOpen(false);
  }

  function onSaveNewImage() {
    const newImage = {
      image,
      piece,
      description,
      observation,
      id: editingValues?.id || Math.random().toString(36).substring(7),
      status: editingValues?.status || 1,
    };

    if (isFixedChecklist) {
      const existingFixedChecklist =
        values.entry_checklist?.fixed_checklist || {};

      const fixedResult = {
        ...existingFixedChecklist,
        [editingIndex]: newImage,
      };

      onChange('entry_checklist', {
        image_register: values.entry_checklist?.image_register,
        fixed_checklist: fixedResult,
      });
    } else {
      if (editingIndex !== null) {
        const updatedValues = [
          ...(values.entry_checklist?.image_register || []),
        ];
        updatedValues[editingIndex] = newImage;
        onChange('entry_checklist', {
          image_register: updatedValues,
          fixed_checklist: values.entry_checklist.fixed_checklist,
        });
      } else {
        onChange(
          'entry_checklist',
          values.entry_checklist?.image_register
            ? {
                image_register: [
                  ...values?.entry_checklist?.image_register,
                  newImage,
                ],
                fixed_checklist: values?.entry_checklist?.fixed_checklist,
              }
            : {
                image_register: [newImage],
                fixed_checklist: values?.entry_checklist?.fixed_checklist,
              }
        );
      }
    }

    closeModal();
    setEditingIndex(null);
  }

  const [parts, setParts] = useState([]);

  useEffect(() => {
    loadParts();
  }, [isOpen]);

  const loadParts = async () => {
    let { data, error } = await supabase
      .from('Part')
      .select('*')
      .eq('company', company.id)
      .is('deleted_at', null);
    if (!error) {
      const result = data.map((item) => ({ label: item.name, value: item.id }));
      setParts(result);
    }
  };

  return (
    <>
      <Modal
        onRequestClose={closeModal}
        className={'prospera-modal edit-piece-modal'}
        isOpen={isOpen}
      >
        <ModalBody className="modal-body">
          <div
            style={{ left: '50px' }}
            className="modal-container edit-piece-modal-container"
          >
            <div className="modal-header">
              <div className="header-title">
                <h1 className="modal-title">
                  {' '}
                  {editingValues ? 'Editando' : 'Registrando'}
                </h1>
              </div>
            </div>

            <div className="os-entry-checklist-actions-button-container">
              <DefaultButton
                disabled={!image}
                onClick={onSaveNewImage}
                className="os-entry-checklist-savebutton"
                label={isMobile ? '' : 'Salvar'}
                icon={<AiOutlineCheck className="button-icon" />}
              />

              <DefaultButton
                className="os-entry-checklist-cancelbutton"
                label={isMobile ? '' : 'Cancelar'}
                icon={<AiOutlineClose className="button-icon-cancel" />}
                onClick={() => closeModal()}
              />
            </div>

            <div className="os-entry-checklist-register-inputs-container">
              <div>
                <DropzoneInput
                  table={'parts'}
                  onChange={(value) => setImage(value)}
                  label={'Imagem'}
                  value={image}
                  single
                  showCameraOption
                  className="edit-piece-modal-input"
                />
              </div>
              <div className="size-dropdown">
                <div className="void-class">
                  <SelectInput
                    onChange={(value) => setPiece(value)}
                    placeholder={'Escolha a peça'}
                    label={'Peça'}
                    options={parts}
                    defaultValue={piece}
                  />
                </div>
              </div>
              <div className="size-dropdown">
                <div className="void-class">
                  <SelectInput
                    onChange={(value) => setDescription(value)}
                    placeholder={'Descrição da peça'}
                    label={'Descrição da peça'}
                    options={damageStatuses}
                    defaultValue={description}
                  />
                </div>
              </div>
              <LabelInput
                label={'Observações'}
                className="remove-margin"
                type={'textarea'}
                inputClassname={'os-entry-checklist-textarea'}
                onChange={(value) => setObservation(value)}
                value={observation}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
